<template>
  <div :class="['domain-card', !editableDomainName || 'editable']">
    <div class="head">
      <h3>
        <span v-html="editableDomainName ? $t('domains.selectDomainName.title') : domainObj.name"></span>
        <v-progress-circular :size="20" width="2" color="primary" indeterminate v-if="loading" class="ml-3" top/>
      </h3>
      <ul class="options">
        <li
            v-for="(option, index) in domainControl"
            :value="option.action"
            :key="index"
            :class="option.action"
        >
          <v-btn
              :ripple="false"
              icon
              :disabled="option.action === 'edit' && !isValidDomain"
              @click="handleOptionClick(option.action, index)"
          >
            <v-icon>
              {{ editableDomainName && option.action === 'edit' ? 'sr-icon-done' : option.icon }}
            </v-icon>
          </v-btn>
        </li>
      </ul>
    </div>

    <domain-name
        ref="domainName"
        :domain-index="index"
        :domain-key="domainObj.id"
        :editable-domain-name="editableDomainName"
        :currency-info="currencyInfo"
        :initial-domain-opt="initialDomainOpt"
        :free-domain-info="freeDomainInfo"
        :domain-type="domainType"
        :init-data="initData"
        :init-upsell-data="initUpsellData?.ssl"
        @domainName="getDomainName($event)"
        @validDomain="getValidDomain($event)"
        @loading="getLoading($event)"
        @updateBulkData="updateDomain($event)"
        :domains-card="domainsCard"
        :bulk="bulk"
    />

    <dialog-form
        content-class="dialog-form"
        v-bind="$attrs"
        v-on="$listeners"
        :show="showConfirmDelete"
        @close="showConfirmDelete = false"
        :activator="false"
        maxWidth="400"
        showActions
        :buttonSubmit="$t('yes')"
        @confirm="handleConfirmDelete"
    >
      <div v-html="$t('bulk.confirmDomainDelete', {domain: domainObj.name})"></div>
    </dialog-form>
  </div>
</template>

<script>
  import DialogForm from '@/shared/components/DialogForm/DialogForm.vue';
  import DomainName from "./DomainName.vue";

  export default {
    name: "DomainBlock",
    components: {
      DialogForm,
      DomainName,
    },
    props: {
      index: { type: Number, default: 0 },
      domainName: { type: String, default: '' },
      domainObj: { type: Object, default: () => ({ name: ''}) },
      currencyInfo: { type: [Object, Array], default: () => ({}) },
      initialDomainOpt: { type: String },
      freeDomainInfo: { type: [Object, Array], default: () => ([]) },
      domainType: { type: String },
      initUpsellData: { type: [Object, Array], default: () => ([]) },
      domainsCard: { type: [Array], default: () => ([{}]) },
      bulk: { type: [Object], default: () => ({}) },
    },
    data() {
      return {
        domainControl: [
          {action: 'edit', icon: 'sr-icon-edit'},
          {action: 'delete', icon: 'sr-icon-delete'},
        ],
        editableDomainName: false,
        showConfirmDelete: false,
        loading: false,
        initData: {
          domain: this.domainObj.name,
          domainoption: 'register',
        },
        isValidDomain: false,
        customFields: undefined
      }
    },
    mounted() {
      if(!this.domainObj?.name) {
        this.getValidDomain()
      }
    },
    methods: {
      handleOptionClick(action) {
        if (action === 'edit') {
          this.editableDomainName = !this.editableDomainName;
        } else {
          this.showConfirmDelete = true
        }
      },
      handleConfirmDelete() {
        this.$emit('remove-domain', this.domainObj);
        this.showConfirmDelete = false;
      },
      getLoading(val) {
        this.loading = val;
      },
      getDomainName(domain) {
        this.initData.domain = domain;

        if (this.initData?.domain?.isValidDomain === true) {
          const updatedDomain = { domain: this.initData.domain, customfields: this.customFields };
          this.$emit('update-domain', { index: this.index, updatedDomain });
        }
      },
      getValidDomain(valid) {
        this.isValidDomain = valid;
        if(!this.isValidDomain) {
          this.editableDomainName = true
        }
      },
      updateDomain(data = {}) {
        const updatedDomain = {
          domain: this.initData.domain,
          customfields: this.customFields,
          ...data
        };

        if (data.customfields) {
          this.customFields = data.customfields;
        }

        this.$emit('update-domain', { index: this.index, updatedDomain });
      },
      validateDomainName() {
        return this.$refs.domainName?.validateCustomFields();
      }
    }
  }
</script>

<style lang="scss">
  .domain-card {
    border: 1px solid $gray-soft;
    border-radius: 7px;
    padding: 24px 20px 20px;

    @media (max-width: $tablet) {
      padding: 8px 20px;
    }

    &:not(:last-child) {
      margin-bottom: 24px;
    }

    &.editable {

      .head {
        margin-bottom: 20px;
      }

      .options {

        .edit {
          .v-icon {
            font-size: 23px;
          }
        }
      }
    }

    .head {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-right: -15px;
      width: calc(100% + 15px);

      @media (max-width: $tablet) {
        margin-right: 0;
        width: 100%;
      }

      h3 {
        max-width: calc(100% - 100px);
        padding-right: 10px;
        margin-bottom: 0;

        @media (max-width: $tablet) {
          order: 2;
          max-width: 100%;
          width: 100%;
        }
      }
    }

    .options {
      display: flex;
      align-items: center;
      margin-left: auto;
      max-width: 100px;
      list-style: none;
      padding: 0;

      @media (max-width: $tablet) {
        order: 1;
        width: 100%;
        max-width: 100%;
        justify-content: end;
        margin-bottom: 8px;
      }

      li {
        &.edit {

          .v-btn {
            &:hover {
              background-color: rgba($primary, .2);

              .v-icon {
                color: $primary;
              }
            }
          }
        }

        &.delete {

          .v-btn {
            &:hover {
              background-color: rgba($red, .2);

              .v-icon {
                color: $red;
              }
            }
          }
        }

        .v-btn {
          border-radius: 50%;
          background-color: transparent;
          color: $gray;
          display: inline-flex;
          height: 44px;
          width: 44px;
          align-items: center;
          justify-content: center;
          transition: $transition;

          &:before {
            display: none;
          }
        }

        .v-icon {
          font-size: 18px;
        }

        @media (max-width: $tablet) {

          &:not(:first-child) {
            margin-left: 6px;
          }

          &.edit {

            .v-btn {
              background-color: rgba($primary, .2);

              .v-icon {
                color: $primary;
              }
            }
          }

          &.delete {

            .v-btn {
              background-color: rgba($red, .2);

              .v-icon {
                color: $red;
              }
            }
          }
        }

      }
    }
  }
</style>
